import useTracker from '@hooks/useTracker';
import {
  CLICK_LOGOUT_CONFIRM,
  CLICK_REFERRAL_LANDING_PAGE,
  CLICK_REFERRAL_BONUS_HISTORY,
  CLICK_START_KYC,
  CLICK_PROFILE,
  CLICK_TOP_UP_BUTTON,
  CLICK_KABAR,
  CLICK_HELP_CENTER_MENU,
} from '@services/trackerConst';

const menubarProps = {
  'entry point': 'menu bar',
};

const homeIconProps = {
  'entry point': 'home icon',
};

const profileProps = {
  'entry point': 'profile',
};

const useEventTracker = () => {
  const { trackEvent, setUserId, resetTracker } = useTracker();

  const eventClickAto = () => {
    trackEvent('click_ato', menubarProps);
  };

  const eventClickLogout = () => {
    trackEvent(CLICK_LOGOUT_CONFIRM);
    setUserId(null);
    resetTracker();
  };

  const eventClickKabar = () => {
    trackEvent(CLICK_KABAR);
  };

  const eventClickReferralPage = () => {
    trackEvent(CLICK_REFERRAL_LANDING_PAGE, homeIconProps);
  };

  const eventClickReferralBonusHistory = () => {
    trackEvent(CLICK_REFERRAL_BONUS_HISTORY);
  };

  const eventStartKyc = () => {
    trackEvent(CLICK_START_KYC, profileProps);
  };

  const eventClickProfile = () => {
    trackEvent(CLICK_PROFILE);
  };

  const eventClickTopUp = () => {
    trackEvent(CLICK_TOP_UP_BUTTON, profileProps);
  };

  const eventClickHelpCenter = () => {
    trackEvent(CLICK_HELP_CENTER_MENU);
  };

  const eventClickMembership = (props) => {
    trackEvent('click_membership_tier_benefits', props);
  };

  return {
    eventClickAto,
    eventClickLogout,
    eventClickKabar,
    eventClickReferralPage,
    eventClickReferralBonusHistory,
    eventStartKyc,
    eventClickProfile,
    eventClickTopUp,
    eventClickHelpCenter,
    eventClickMembership,
  };
};

export default useEventTracker;
